import styles from './UnavailableMessage.module.scss';
const UnavailableMessage = () => {
  return <p className={styles.unavailable_message} data-sentry-component="UnavailableMessage" data-sentry-source-file="UnavailableMessage.tsx">
      We&rsquo;re sorry, but this video is not available.
    </p>;
};
export default UnavailableMessage;